import { initAccordion } from '$c3template/Frontend/accordion.js';
import { fakeUploadField } from '$c3template/Frontend/form.js';
import { mobileTouchFix } from '$c3base/mobile-touch-fix.js';
import { overrideMobileNav } from '$c3template/Frontend/override-mobile-nav.js';
import { initMobileMenu } from '$c3template/Frontend/menu.js';
import { initFade } from '$c3template/Frontend/fade.js';

let headerPadding = 30;

/**
 *
 * @param {{
 *     headerPadding: number
 * }} config
 */
export function configure(config) {
    headerPadding = config.headerPadding;
}

overrideMobileNav(headerPadding);

$(function () {
    mobileTouchFix($('.page-header nav'));
    initAccordion();
    initMobileMenu();
    fakeUploadField();

});

$(window).on('load', function () {
    initFade();
});